import useAuth from "../../../auth/useAuth.js";
import { Alerts } from "../../../components/alerts/Alerts.tsx";
import { creteCommunicationChannel, updateCommunicationChannel } from "../../../config.js";

export const useCommunicationChannelCustomer = () => {

    const auth = useAuth();
    const token = auth.globals.token;

    const {
        showErrorRequest,
        alertSuccess
    } = Alerts();


    const registerNewChannel = async (body) => {
        if (body) {
            try {
                let res = await creteCommunicationChannel(token, body);
                let data = await res.json()
                if (res.ok) {
                    alertSuccess("Crear canal de comunicación", "El canal se creo correctamente", "/communication-channel")
                    return data;
                } else {
                    if (res.status === 401 || res.status === 403) {
                        showErrorRequest("No tiene autorización o su sesión ha expirado", auth)
                    }
                    return undefined;
                }
            } catch (errorRequest) {
                showErrorRequest(errorRequest, auth)
                return undefined;
            }
        }
    }

    const updateCommunicationChannelCustomer = async (expenseId, body) => {
        if (body && expenseId !== "") {
            try {
                let res = await updateCommunicationChannel(token, body, expenseId);
                let data = await res.json()
                if (res.ok) {
                    alertSuccess("Editar Canal de comunicación", "El canal se modifico correctamente", undefined)
                    return data;
                } else {
                    if (res.status === 404) {
                        showErrorRequest("Registro no encontrado", auth)
                    }
                    if (res.status === 401 || res.status === 403) {
                        showErrorRequest("No tiene autorización o su sesión ha expirado", auth)
                    }
                    return undefined;
                }
            } catch (errorRequest) {
                showErrorRequest(errorRequest, auth)
                return undefined;
            }
        }
    }


    return {
        //properties

        //methods
        updateCommunicationChannelCustomer,
        registerNewChannel,

    }
}